"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CACHE_POSTFIX = exports.PAGES_TO_EXCLUDE_FROM_CACHE = exports.PAGES_EXT = exports.PAGES_DIR = void 0;
exports.PAGES_DIR = "pages/";
exports.PAGES_EXT = ".tsx";
exports.PAGES_TO_EXCLUDE_FROM_CACHE = ["404.tsx", "_app.tsx", "_document.tsx"];
exports.CACHE_POSTFIX = "__iw__cached";
